/**
 * @fileOverview 权限验证相关
 * @author: kirkzheng
 * @time: 2016-05-24
 */

import cookie from './cookie';
import config from '../constants/config';
import tsaStorageKey from '@/constants/tsaStorageKey.js';
import { log } from './console';

/**
 * 获取g_tk
 * @return {String} token
 */
export const getACSRFToken = () => {
  const str = cookie.get('gdt_protect') || cookie.get('skey');
  let hash = 5381;
  let i = 0;
  let len = 0;

  i = 0;
  len = str.length;

  for (; i < len; ++i) {
    hash += (hash << 5) + str.charCodeAt(i);
  }

  return hash & 0x7fffffff;
};

/**
 * 退出，清除cookie
 * @param  {String} targetUrl 跳转的url
 * @return {Void}
 */
export const logout = (targetUrl = '') => {
  const cookies = ['uin', 'skey', 'zzpaneluin', 'zzpanelkey'];
  const currentDomainCookies = ['elogininfo', 'gdt_elogin'];
  const storageKey = tsaStorageKey || {};
  let i = 0;
  let len = 0;
  let key = '';

  i = 0;
  len = cookies.length;

  for (; i < len; i++) {
    cookie.del(cookies[i], config.SITE.parentDomain, '/');
  }

  i = 0;
  len = currentDomainCookies.length;
  for (; i < len; i++) {
    cookie.del(currentDomainCookies[i], config.SITE.domain, '/');
  }

  try {
    for (key in storageKey) {
      if (storageKey[key]) {
        ;((storageName) => {
          setTimeout(() => {
            window.sessionStorage.removeItem(storageName);
          }, 10);
        })(storageKey[key]);
      }
    }
  } catch (e) {
    log(e.message);
  }

  if (typeof GDTSSO === 'object' && GDTSSO.usingSSO && typeof GDTSSO.logout !== 'undefined') {
    GDTSSO.logout().then(
      (response = {}) => {
        if (response.ret == 0) {
          if (targetUrl) {
            top.location.href = targetUrl;
          } else {
            top.location.href = config.SITE.portalUrl;
          }
        } else {
          alert(response.msg || '退出失败，请重试！');
        }
      },
      (response) => {
        alert('退出失败，请重试！');
      },
    );
  } else {
    // 清除storageKey貌似不太及时，稍微延迟下再跳走吧
    setTimeout(() => {
      if (targetUrl) {
        top.location.href = targetUrl;
      } else {
        top.location.href = config.SITE.portalUrl;
      }
    }, 50);
  }
};

/*
 * 文件默认到处
 */
export default {
  getACSRFToken,
  logout,
};
